import FormTitle from '@core/components/FormTitle';
import { TextLabel } from '@core/components/Inputs';
import { Grid } from '@material-ui/core';
import NP from 'number-precision';
import React from 'react';

const getCurrency = (value) => {
  if (value === null || value === undefined || value === '') return ' - ';
  const numberValue = Number(value);

  if (isNaN(numberValue) || numberValue === 0) return ' - ';

  return new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(numberValue);
};

const formatTipoAproveitamento = (tipo) => {
  switch (tipo) {
    case 'CREDITO_PARCIAL':
      return 'Crédito parcial';
    case 'CREDITO_INTEGRAL':
      return 'Crédito integral';
    default:
      return 'Não aproveita crédito';
  }
};

const VisualizarCompraAproveitamentoCredito = ({ values, valorTotalCategorias = 0 }) => {
  const PARCIAL = values?.tipoAproveitamentoCredito === 'CREDITO_PARCIAL';
  const INTEGRAL = values?.tipoAproveitamentoCredito === 'CREDITO_INTEGRAL';

  const aliquotaCbs = NP.divide(Number(values?.aliquotaCbs) || 0, 100);
  const aliquotaIbs = NP.divide(Number(values?.aliquotaIbs) || 0, 100);

  const creditoIbs = Number(values?.valorCreditoIbs) || 0;
  const creditoCbs = Number(values?.valorCreditoCbs) || 0;

  const valorBaseCbs = NP.times(valorTotalCategorias, aliquotaCbs);
  const valorBaseIbs = NP.times(valorTotalCategorias, aliquotaIbs);

  const percentual = NP.divide(Number(values?.percentualCredito) || 0, 100);

  const valorParcialCbs = NP.times(valorBaseCbs, percentual);
  const valorParcialIbs = NP.times(valorBaseIbs, percentual);

  const temCreditoLancado = !!values?.valorCreditoIbs || !!values?.valorCreditoCbs;
  const creditoTotal = temCreditoLancado ? creditoIbs + creditoCbs : '-';

  return (
    <>
      <div>
        <FormTitle title="Aproveitamento de crédito IBS/CBS" />
      </div>
      <Grid container spacing={3} className="mb-8">
        <Grid item xs={12} sm={4} md={4}>
          <TextLabel
            id="tipoAproveitamentoCredito"
            label="Aproveitamento de crédito"
            value={formatTipoAproveitamento(values?.tipoAproveitamentoCredito)}
          />
        </Grid>

        {PARCIAL && (
          <>
            <Grid item xs={12} sm={4} md={4}>
              <TextLabel
                id="percentualCredito"
                label="Percentual de crédito (%)"
                value={values?.percentualCredito ? values?.percentualCredito : '-'}
              />
            </Grid>
            <Grid item xs={12} sm={2} md={2}>
              <TextLabel id="aliquotaIbs" label="Alíquota IBS %" value={values?.aliquotaIbs || '-'} />
            </Grid>
            <Grid item xs={12} sm={2} md={2}>
              <TextLabel id="aliquotaCbs" label="Alíquota CBS %" value={values?.aliquotaCbs || '-'} />
            </Grid>
            <Grid item xs={12} sm={12} style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              <Grid>
                <span>{`Valores base: IBS = R$ ${getCurrency(valorBaseIbs)} | CBS = R$ ${getCurrency(
                  valorBaseCbs
                )}`}</span>
              </Grid>
              <Grid>
                <span>
                  {`Valores parcial: IBS = R$ ${getCurrency(valorParcialIbs)} | CBS = R$ ${getCurrency(
                    valorParcialCbs
                  )}`}
                </span>
              </Grid>
            </Grid>
          </>
        )}
        {INTEGRAL && (
          <>
            <Grid item xs={12} sm={12} md={12} style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              <Grid item>
                <TextLabel id="labelValoresCalculados" label="Valores de crédito calculados:" value={' '} />
              </Grid>

              <Grid item xs={12} style={{ display: 'flex' }}>
                <Grid item xs={12} sm={4} md={4}>
                  <TextLabel id="valorCreditoIbs" label="Crédito IBS (R$)" value={getCurrency(creditoIbs)} />
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                  <TextLabel id="valorCreditoCbs" label="Crédito CBS (R$)" value={getCurrency(creditoCbs)} />
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                  <TextLabel id="valorCreditoTotal" label="Crédito total (R$)" value={getCurrency(creditoTotal)} />
                </Grid>
              </Grid>
            </Grid>
          </>
        )}
      </Grid>
    </>
  );
};

export default VisualizarCompraAproveitamentoCredito;
